
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"45","height":"45"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 0h45v45H0z","fill":"none"}}),_c('path',{attrs:{"d":"M36.281 18.825a14.048 14.048 0 00-26.25-3.75A11.245 11.245 0 0011.25 37.5h24.375a9.348 9.348 0 00.656-18.675zm-4.406 5.55L22.5 33.75l-9.375-9.375h5.625v-7.5h7.5v7.5z"}})])
          )
        }
      }
    